import styled from "styled-components";
import { FlexColumn, FlexRow } from "styles/layout";
import { NoteText } from "styles/text";
import { Theme } from "theme";

// todo - font size more standard in styling, e.g. panel has the media queries at that level for font size?
export const FiltersContainer = styled(FlexColumn)`
  row-gap: 20px;

  @media (max-width: 600px) {
    font-size: 11pt;
  }
`;

export const FilterRow = styled(FlexRow)`
  column-gap: 40px;
  row-gap: 10px;
  flex-wrap: wrap;
`;

export const InaccurateStats = styled(NoteText)`
  margin-right: ${Theme.bigPanelPaddingHorizontal};
  margin-bottom: 3px;
`;
